const SESSION_TOKEN = process.env.REACT_APP_LOCAL_TOKEN_NAME
const SESSION_REFRESHTOKEN = process.env.REACT_APP_LOCAL_REFRESH_TOKEN_NAME

const TStorage = {
  AccessToken: () => localStorage.getItem(SESSION_TOKEN),
  RefreshToken: () => localStorage.getItem(SESSION_REFRESHTOKEN),
}

export default TStorage
